import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CursorEffect = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const [hoverText, setHoverText] = useState('');

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const handleMouseOver = (e) => {
      const target = e.target.closest('button, a, [role="button"]');
      if (target) {
        setIsHovering(true);
        // Get the aria-label, title, or text content for the hover effect
        const text = target.getAttribute('aria-label') || 
                    target.getAttribute('title') || 
                    target.textContent;
        setHoverText(text.trim());
      } else {
        setIsHovering(false);
        setHoverText('');
      }
    };

    const handleMouseOut = () => {
      setIsHovering(false);
      setHoverText('');
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('mouseout', handleMouseOut);

    // Hide default cursor
    document.body.style.cursor = 'none';

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('mouseout', handleMouseOut);
      document.body.style.cursor = 'default';
    };
  }, []);

  return (
    <>
      <motion.div
        className="cursor-dot"
        animate={{
          x: mousePosition.x - 5,
          y: mousePosition.y - 5,
          scale: isHovering ? 0.5 : 1,
        }}
        transition={{
          type: "spring",
          damping: 50,
          stiffness: 500,
          restDelta: 0.001
        }}
      />
      <motion.div
        className="cursor-ring"
        animate={{
          x: mousePosition.x - 20,
          y: mousePosition.y - 20,
          scale: isHovering ? 1.8 : 1,
          borderColor: isHovering ? 'var(--primary-color)' : 'rgba(56, 189, 248, 0.5)',
          opacity: isHovering ? 1 : 0.5,
        }}
        transition={{
          type: "spring",
          damping: 35,
          stiffness: 400,
          restDelta: 0.001
        }}
      />
      <motion.div
        className="cursor-trail"
        animate={{
          x: mousePosition.x - 15,
          y: mousePosition.y - 15,
          scale: isHovering ? 1.5 : 1,
          opacity: isHovering ? 0.8 : 0.3,
        }}
        transition={{
          type: "spring",
          damping: 25,
          stiffness: 300,
          restDelta: 0.001
        }}
      />
      <AnimatePresence>
        {isHovering && hoverText && (
          <motion.div
            className="cursor-text"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            style={{
              x: mousePosition.x + 15,
              y: mousePosition.y + 15
            }}
            transition={{
              type: "spring",
              damping: 25,
              stiffness: 300
            }}
          >
            {hoverText}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default CursorEffect;